import React$1 from 'react';

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

function consumeContext(InnerConsumer, ContextAPI) {
  // Ignore falsy values to prevent unhandled errors.
  // Only Arrays and React Context are allowed.
  if (!ContextAPI) {
    return InnerConsumer;
  }

  return React$1.forwardRef(function (_ref, ref) {
    var _ref$__context_accum_ = _ref.__context_accum__,
        parentContext = _ref$__context_accum_ === undefined ? {} : _ref$__context_accum_,
        ownProps = objectWithoutProperties(_ref, ['__context_accum__']);
    return React$1.createElement(
      ContextAPI.Consumer,
      null,
      function (context) {
        return React$1.createElement(InnerConsumer, _extends({}, ownProps, {
          __context_accum__: _extends({}, parentContext, context),
          ref: ref
        }));
      }
    );
  });
}

function withContext(ContextAPIs, mapContextToProps) {
  return function (ComposedComponent) {
    // Recursively consume the APIs only once.
    return ContextAPIs.reduce(consumeContext, React$1.forwardRef(function (_ref2, ref) {
      var raw = _ref2.__context_accum__,
          ownProps = objectWithoutProperties(_ref2, ['__context_accum__']);
      return React$1.createElement(ComposedComponent, _extends({}, ownProps, mapContextToProps(raw, ownProps), {
        ref: ref
      }));
    }));
  };
}

/**
 * Temporary workaround to fix react-redux issue with forwardRef.
 * This workaround will be removed on v3.
 *
 * Issue: https://github.com/pgarciacamou/react-context-consumer-hoc/issues/6
 */
function noRef(ContextAPIs, mapContextToProps) {
  return function (ComposedComponent) {
    var Component = withContext(ContextAPIs, mapContextToProps)(ComposedComponent);
    return function (props) {
      return React$1.createElement(Component, props);
    };
  };
}

withContext.noRef = noRef;

var mapContextToProps = function mapContextToProps(context) {
  return context;
};

function withContextAsProps() {
  for (var _len = arguments.length, ContextAPIs = Array(_len), _key = 0; _key < _len; _key++) {
    ContextAPIs[_key] = arguments[_key];
  }

  return withContext(ContextAPIs, mapContextToProps);
}

/**
 * Temporary workaround to fix react-redux issue with forwardRef.
 * This workaround will be removed on v3.
 *
 * Issue: https://github.com/pgarciacamou/react-context-consumer-hoc/issues/6
 */
function noRef$1() {
  for (var _len2 = arguments.length, ContextAPIs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    ContextAPIs[_key2] = arguments[_key2];
  }

  return function (ComposedComponent) {
    var Component = withContext(ContextAPIs, mapContextToProps)(ComposedComponent);
    return function (props) {
      return React.createElement(Component, props);
    };
  };
}

withContextAsProps.noRef = noRef$1;

/**
 * DEPRECATED
 * ==========
 *
 * This implementation has been deprecated since v2.0.0.
 * This implementation should be completely removed in v3.x.
 *
 * WARNING:
 *
 * Deconstructing the context into a new object causes issues with PureComponents
 * where it expects the object not to be mutated if nothing has changed.
 *
 * Furthermore, creating a new object is not flexible and can break immutability
 * of some projects that use ImmutableJS (or alike), as well as memoization.
 *
 * Use the new implementation of `withContext` (> v1.x) where you can specify
 * a selector function mapContextToProps.
 */

function consumeContext$1(ChildConsumer, ContextAPI) {
  return React$1.forwardRef(function (_ref, ref) {
    var _ref$context = _ref.context,
        parentContext = _ref$context === undefined ? {} : _ref$context,
        props = objectWithoutProperties(_ref, ['context']);
    return React$1.createElement(
      ContextAPI.Consumer,
      null,
      function (context) {
        return React$1.createElement(ChildConsumer, _extends({}, props, {
          ref: ref,
          context: _extends({}, parentContext, context)
        }));
      }
    );
  });
}

function UNSAFE_withContext() {
  for (var _len = arguments.length, ContextAPIs = Array(_len), _key = 0; _key < _len; _key++) {
    ContextAPIs[_key] = arguments[_key];
  }

  return function (ComposedComponent) {
    // Recursively consume the APIs only once.
    return ContextAPIs.reduce(consumeContext$1, ComposedComponent);
  };
}

/**
 * Temporary workaround to fix react-redux issue with forwardRef.
 * This workaround will be removed on v3.
 *
 * Issue: https://github.com/pgarciacamou/react-context-consumer-hoc/issues/6
 */
function noRef$2() {
  for (var _len2 = arguments.length, ContextAPIs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    ContextAPIs[_key2] = arguments[_key2];
  }

  return function (ComposedComponent) {
    var Component = UNSAFE_withContext.apply(undefined, ContextAPIs)(ComposedComponent);
    return function (props) {
      return React$1.createElement(Component, props);
    };
  };
}

UNSAFE_withContext.noRef = noRef$2;

export { withContext, withContextAsProps, UNSAFE_withContext };
//# sourceMappingURL=index.es.js.map
